import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
	row: {
		border: '1px solid #E2E8F0',
		boxShadow: '0px 2px 2px rgb(117 139 183 / 10%)',
		backgroundColor: '#fff',
		'& td': {
			padding: '8px 16px',
		},
	},
	container: {
		marginBottom: 16,
	},
	tableBody: {
		'& .MuiTableCell-root': {
			borderBottom: 'none',
		},
	},
	card: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-star',
		padding: theme.spacing(1, 2),
		margin: theme.spacing(1, 0),
	},
	cardActions: {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
	desktop: {
		display: 'table',
		[theme.breakpoints.down('md')]: {
			display: 'none',
		},
	},
	mobile: {
		display: 'none',
		[theme.breakpoints.down('md')]: {
			display: 'flex',
			padding: 8,
			width: '100%',
		},
	},
}));
